

module.exports = __webpack_require__.stylable.create(
    "BuyerNote1565930848",
    {"classes":{"root":"BuyerNote1565930848__root","textArea":"BuyerNote1565930848__textArea"},"vars":{},"stVars":{"textColor":"'\"color(--cart_textColor)\"'","placeholderColor":"'\"opacity(--cart_textColor, 0.6)\"'","textFont":"'\"font({theme: 'cart_textFontStyle', size: '16px'})\"'"},"keyframes":{}},
    "",
    14,
    "BuyerNote1565930848",
    null
);
